import { HashRouter, Routes, Route } from "react-router-dom";
import Main from "./pages/main";
import Project from "./pages/projects"; // Assure-toi que ce chemin est correct
import "./assets/css/setup.css";
import "./assets/css/style.css";

function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/projects" element={<Project />} />
      </Routes>
    </HashRouter>
  );
}

export default App;
